/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useState} from 'react';

import {ViewSpeciesModal} from "../../../Pages/SpeciesLists/Common/Modals/ViewSpeciesModal";

/**
 * The species line's subject: a link that opens the species snapshot the activity recorded.
 *
 * The modal is the reason the four species types could not be plain facts — a supplier cannot hold
 * the open/closed state a modal needs. It works as a subject because a subject may be a node, and a
 * node runs its own hooks where it renders rather than where the facts were built.
 *
 * The species shown is the copy stored on the activity, not the live row, hence the warning: the
 * point of opening it from a feed entry is to see what the species looked like at the time.
 */
export const SpeciesModalSubject = props => {
    const {Species, Label} = props;

    const [showModal, setShowModal] = useState(false);

    return <>
        <ViewSpeciesModal
            show={showModal}
            species={Species}
            onHide={() => setShowModal(false)}
            warning={"The below information is a point-in-time snapshot of the species data which may be outdated. "}
        />
        <a className="link-primary" onClick={_ => setShowModal(true)}>
            {Label}
        </a>
    </>;
};
